import Card from 'garaje/components/ui/card';

<template>
  <Card class="border-carbon-20 mb-8" data-test-approval-property-blocklist>
    <h5 class="text-sm font-bold mb-1">Property block list triggered.</h5>
    <p class="text-sm mb-0">You may contact your property team.</p>
  </Card>
</template>
